import { horizontalLoop } from '../utils/horizontalLoop';

export default function initGallery() {
    const sliders = document.querySelectorAll('.gallery');

    sliders.forEach(slider => {
        const items = slider.querySelectorAll('.gallery__item');
        const pauseBtn = slider.querySelector('.gallery__pause');

        if (items.length === 0) return;

        const config = {
            repeat: -1,
            paddingRight: 28,
            speed: 0.4,
        };

        // Items have a definite CSS width, so offsetLeft/offsetWidth are stable
        // before images finish loading — no need to wait. Waiting on lazy-loaded
        // offscreen images would block the loop indefinitely (the `load` event
        // doesn't fire until they enter the viewport).
        const loop = horizontalLoop(items, config);

        if (pauseBtn && loop) {
            pauseBtn.addEventListener('click', () => {
                const isPaused = loop.paused();
                loop.paused(!isPaused);

                if (!isPaused) {
                    pauseBtn.classList.add('is-paused');
                    pauseBtn.setAttribute('aria-label', 'Play animation');
                    pauseBtn.setAttribute('title', 'Play animation');
                } else {
                    pauseBtn.classList.remove('is-paused');
                    pauseBtn.setAttribute('aria-label', 'Pause animation');
                    pauseBtn.setAttribute('title', 'Pause animation');
                }
            });
        }
    });
}
